<div id="st-app-app-wrapper" class="app-wrapper" [class.t1-app]="isTemplate1">
  <!-- Template 1: animated glass backdrop the frosted surfaces read against -->
  <div class="t1-bg-blobs" *ngIf="isTemplate1" aria-hidden="true">
    <span class="t1-bg-blob t1-bg-blob--1"></span>
    <span class="t1-bg-blob t1-bg-blob--2"></span>
    <span class="t1-bg-blob t1-bg-blob--3"></span>
    <span class="t1-bg-blob t1-bg-blob--4"></span>
    <span class="t1-bg-blob t1-bg-blob--5"></span>
    <span class="t1-bg-blob t1-bg-blob--6"></span>
    <span class="t1-bg-blob t1-bg-blob--7"></span>
    <span class="t1-bg-blob t1-bg-blob--dark-1"></span>
    <span class="t1-bg-blob t1-bg-blob--dark-2"></span>
    <span class="t1-bg-blob t1-bg-blob--dark-3"></span>
  </div>

  <app-header *ngIf="!hideHeaderAndFooter && !isTemplate1" (languageChange)="changeLanguage($event)"></app-header>
  <stupa-template1-sidebar *ngIf="!hideHeaderAndFooter && isTemplate1"
    (languageChange)="changeLanguage($event)"></stupa-template1-sidebar>
  <!-- Auth panel content, declared once and hosted by whichever shell the
       active template uses, so the two can never drift apart. -->
  <ng-template #authPanel>
    <app-login style="width: 100%;" *ngIf="is_login"></app-login>
    <stupa-forgot-password style="width: 100%;" *ngIf="is_forgot_password"></stupa-forgot-password>
    <app-signup style="width: 100%;" *ngIf="is_signup"></app-signup>
  </ng-template>

  @if (isTemplate1) {
    <!-- Template 1 signs in through a centred modal rather than an edge drawer:
         a full-height right-hand panel leaves most of its area empty for a
         six-field form, and pushes the reader's eye off to one side. Appended
         to <body> so it is not trapped under `.t1-shell-offset`'s stacking
         context (see TEMPLATE1_DEVLOG.md's sidebar z-index note). -->
    <p-dialog [(visible)]="isDialogVisible" (onHide)="closeDialog()" [modal]="true" [draggable]="false"
      [resizable]="false" [dismissableMask]="true" [closable]="false" [showHeader]="false" [blockScroll]="true"
      [appendTo]="'body'" styleClass="t1-auth-dialog">
      <ng-container *ngTemplateOutlet="authPanel"></ng-container>
    </p-dialog>
  } @else {
    <div id="st-app-authcommonsidebar" class="auth_common_sidebar" [ngClass]="innerHeight < 600 ? 'landScape_view' : ''">
      <p-sidebar styleClass="auth_common_sidebar_modal" [(visible)]="isDialogVisible" (onHide)="closeDialog()"
        [blockScroll]="true" position="right" modal="true" [showCloseIcon]="false" [style]="{width: setWidth}">
        <ng-template pTemplate="header">
          <div id="st-app-block" class="d-flex justify-content-between align-items-center w-100">
            <h3 class="f_16">{{show_login()}}</h3>
            <button type="button" (click)="closeDialog()" (keydown.enter)="closeDialog()" (keydown.space)="$event.preventDefault(); closeDialog()"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.9996 21.4C13.7579 21.4 16.4031 20.3043 18.3535 18.3539C20.3039 16.4035 21.3996 13.7583 21.3996 11C21.3996 8.24176 20.3039 5.59647 18.3535 3.6461C16.4031 1.69572 13.7579 0.600006 10.9996 0.600006C8.24136 0.600006 5.59608 1.69572 3.6457 3.6461C1.69532 5.59647 0.599609 8.24176 0.599609 11C0.599609 13.7583 1.69532 16.4035 3.6457 18.3539C5.59608 20.3043 8.24136 21.4 10.9996 21.4ZM8.76361 7.38601C8.57878 7.21378 8.33432 7.12002 8.08173 7.12448C7.82914 7.12894 7.58814 7.23126 7.4095 7.4099C7.23086 7.58853 7.12854 7.82954 7.12408 8.08213C7.11963 8.33472 7.21339 8.57918 7.38561 8.76401L9.62161 11L7.38561 13.236C7.28982 13.3253 7.21298 13.4329 7.15969 13.5525C7.1064 13.6721 7.07775 13.8012 7.07544 13.9321C7.07313 14.063 7.09721 14.1931 7.14625 14.3145C7.19529 14.4359 7.26828 14.5462 7.36086 14.6388C7.45344 14.7313 7.56373 14.8043 7.68513 14.8534C7.80654 14.9024 7.93658 14.9265 8.06749 14.9242C8.1984 14.9219 8.32751 14.8932 8.44711 14.8399C8.56671 14.7866 8.67435 14.7098 8.76361 14.614L10.9996 12.378L13.2356 14.614C13.3249 14.7098 13.4325 14.7866 13.5521 14.8399C13.6717 14.8932 13.8008 14.9219 13.9317 14.9242C14.0626 14.9265 14.1927 14.9024 14.3141 14.8534C14.4355 14.8043 14.5458 14.7313 14.6384 14.6388C14.7309 14.5462 14.8039 14.4359 14.853 14.3145C14.902 14.1931 14.9261 14.063 14.9238 13.9321C14.9215 13.8012 14.8928 13.6721 14.8395 13.5525C14.7862 13.4329 14.7094 13.3253 14.6136 13.236L12.3776 11L14.6136 8.76401C14.7858 8.57918 14.8796 8.33472 14.8751 8.08213C14.8707 7.82954 14.7684 7.58853 14.5897 7.4099C14.4111 7.23126 14.1701 7.12894 13.9175 7.12448C13.6649 7.12002 13.4204 7.21378 13.2356 7.38601L10.9996 9.62201L8.76361 7.38601Z"
                fill="#B4B2B2" />
            </svg></button>

          </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="authPanel"></ng-container>
      </p-sidebar>
    </div>
  }

  <div id="st-app-router-content" class="router-content"
    [class.t1-shell-offset]="isTemplate1 && !hideHeaderAndFooter">
    <router-outlet />
  </div>
  <app-footer *ngIf="!hideHeaderAndFooter && !hideFooter"
    [class.t1-shell-offset]="isTemplate1"></app-footer>

  <stupa-profile-status-popup [(visible)]="showProfileStatusPopup" [type]="profileStatusPopupType"
    [profileProgress]="profileProgress" (editProfile)="navigateToEditProfile()"
    (popupClose)="showProfileStatusPopup = false"></stupa-profile-status-popup>

  <stupa-payment-response-popup [visible]="showPaymentPopup" [variant]="paymentSuccess ? 'success' : 'failure'"
    [transactionId]="paymentTransactionId" [eventTitle]="paymentPopupEventTitle"
    [detailLines]="getPaymentPopupDetailLines()" [footerPrice]="getPaymentPopupFooterPrice()"
    (visibleChange)="onPaymentPopupVisibleChange($event)" (viewInvoice)="onPaymentPopupViewInvoice()"
    (viewOrderHistory)="onPaymentPopupViewOrderHistory()" (retryPayment)="onPaymentPopupRetry()" />
</div>